function ReactDrawer(props) {
  const [drawerWidth, setDrawerwidth] = React.useState("0");
  const [drawerBackVis, setDrawerBackVis] = React.useState("hidden");
  function drawerSwitch(e) {
    e.preventDefault();
    drawerBackVis == "hidden" ? setDrawerBackVis("visible") : setDrawerBackVis("hidden");
    document.querySelector("body").classList.contains("blockScroll") ? document.querySelector("body").classList.remove("blockScroll") : document.querySelector("body").classList.add("blockScroll");
    if (window.innerWidth < 450) {
      drawerWidth == "0" ? setDrawerwidth(window.innerWidth + "px") : setDrawerwidth("0");
    } else {
      drawerWidth == "0" ? setDrawerwidth("450px") : setDrawerwidth("0");
    }
  }
  if (props.type == "mobile-menu") {
    return /*#__PURE__*/React.createElement("div", {
      className: "react-drawer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "drawerBack",
      onClick: e => drawerSwitch(e),
      style: {
        visibility: drawerBackVis
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "drawerArea",
      style: {
        width: drawerWidth
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "mobile-menu-drawer",
      style: window.innerWidth < 450 ? {
        minWidth: window.innerWidth + "px"
      } : {
        minWidth: "450px"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "absolute mleft"
    }, /*#__PURE__*/React.createElement("button", {
      className: "drawerClose",
      onClick: e => drawerSwitch(e)
    }, "\u2715")), drawerWidth != "0" && /*#__PURE__*/React.createElement(ReactMenu, {
      menuItems: props.menuItems,
      width: drawerWidth,
      minWidth: window.innerWidth < 450 ? window.innerWidth + "px" : "450px"
    }))), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Main Menu",
      className: "site-nav__link site-nav__link--icon",
      onClick: e => drawerSwitch(e)
    }, /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 260 260",
      focusable: "false",
      role: "presentation",
      className: "hamburgerIcon"
    }, /*#__PURE__*/React.createElement("path", {
      d: "m49,57.3c50.7-.2,101.3-.3,152-.5M49,128.3c50.7-.2,101.3-.3,152-.5M49,199.3c50.7-.2,101.3-.3,152-.5",
      style: {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeMiterlimit: 10
      }
    }))));
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: "react-drawer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "drawerBack",
      onClick: e => drawerSwitch(e),
      style: {
        visibility: drawerBackVis
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "drawerArea drawerAreaLeft",
      style: {
        width: drawerWidth,
        background: "white",
        paddingTop: "6rem"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "mobile-menu-drawer",
      style: window.innerWidth < 450 ? {
        minWidth: window.innerWidth + "px"
      } : {
        minWidth: "450px"
      }
    }, /*#__PURE__*/React.createElement("button", {
      style: {
        color: "#171717"
      },
      className: "filterDrawerClose",
      onClick: e => drawerSwitch(e)
    }, "\u2715"), props.children, /*#__PURE__*/React.createElement("button", {
      className: "applyFilterButton",
      onClick: e => drawerSwitch(e)
    }, "Apply Filters"))), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Filters Menu",
      className: "site-nav__link site-nav__link--icon filtersBtn",
      onClick: e => drawerSwitch(e)
    }, "Filters", /*#__PURE__*/React.createElement("img", {
      width: '25px',
      height: "25px",
      alt: "Filter Menu Button",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/icons8-slider-96.png?v=1683232462"
    })));
  }
}
const domContainerFordrawer = document.querySelector('#reactDrawer');
const rootFordrawer = ReactDOM.createRoot(domContainerFordrawer);
rootFordrawer.render( /*#__PURE__*/React.createElement(ReactDrawer, {
  type: "mobile-menu",
  menuItems: domContainerFordrawer.dataset.menuItems
}));
